import TableMatcher from './TableMatcher';

export default TableMatcher;
